import axiosInstance from "../utils/axiosInstance";
import { CUSTOM_PROMPT_SLOTS, CustomPromptButtonConfig } from "../../components/transform/transformConfig";
import { SavedPromptsMap } from "./savedPromptsTypes";

interface GetSavedPromptsApiResponse {
  success: boolean;
  data?: {
    prompts?: Record<string, CustomPromptButtonConfig> | null;
  };
}

const normalizePrompts = (
  prompts: Record<string, CustomPromptButtonConfig>,
): SavedPromptsMap => {
  const normalized: SavedPromptsMap = {};

  for (const [slotKey, value] of Object.entries(prompts)) {
    const slot = Number(slotKey);
    if (
      Number.isInteger(slot) &&
      slot >= 0 &&
      slot < CUSTOM_PROMPT_SLOTS &&
      value &&
      typeof value.title === "string" &&
      typeof value.prompt === "string"
    ) {
      normalized[slot] = {
        title: value.title,
        prompt: value.prompt,
      };
    }
  }

  return normalized;
};

/**
 * Returns the user's saved prompts.
 *
 * - `null` — the user has never saved anything (no record server-side).
 *   Callers should fall back to the built-in defaults.
 * - `{}` — the user deliberately deleted all of their prompts. Callers must
 *   respect the empty state and NOT resurrect defaults (Trello #270).
 * - otherwise — the saved map.
 */
export const getSavedPrompts = async (): Promise<SavedPromptsMap | null> => {
  try {
    const response = await axiosInstance.get<GetSavedPromptsApiResponse>("/saved-prompts");
    const prompts = response.data.data?.prompts;
    if (prompts === null || prompts === undefined) {
      return null;
    }
    return normalizePrompts(prompts);
  } catch (error: any) {
    throw new Error(error.response?.data?.message || "Failed to load saved prompts.");
  }
};
